import React from "react";
import { NotificationLogList } from "components/notification-log/NotificationLogList";
import { Provider } from "components/notification-log/NotificationLogContext";

export const NotificationLogs = () => {
    return (
        <Provider>
            <NotificationLogList />
        </Provider>
    );
};
